import * as React from 'react';
import type { PlannerProps } from '../../Components/Planner/Planner';
import { Planner } from '../../Components/Planner/Planner';
import styles from './OnlineStudyPlannerSection.module.css';

export interface OnlineStudyPlannerSectionProps extends PlannerProps {
    id: string;
    heading: string;
    teaser?: string;
}

export const OnlineStudyPlannerSection: React.FC<OnlineStudyPlannerSectionProps> = props => {
    const { id, heading, teaser, ...restProps } = props;

    return (
        <section id={id} className={styles.OnlineStudyPlannerSection}>
            <div className={styles.Header}>
                <h2 className={styles.Heading}>{heading}</h2>
                {teaser && <span className={styles.Teaser}>{teaser}</span>}
            </div>
            <Planner {...restProps} />
        </section>
    );
};
